module.exports = __webpack_public_path__ + "static/img/cont57 (6).0a44f70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (6).jpg
// module id = RuXf
// module chunks = 0